// extracted by mini-css-extract-plugin
export default {"container":"kaltura__container__ebCfC","keepAspectRatio":"kaltura__keepAspectRatio__fkI9p","onVideoPage":"kaltura__onVideoPage__DeT5l","fullScreen":"kaltura__fullScreen__NosWQ"};